export interface ManhuaChapter {
  id: string;
  number: number;
  title: string;
  createdAt: string;
}

export interface Manhua {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  rating: number;
  latestChapter: string;
  updatedAt: string;
  chapters: ManhuaChapter[];
  tags: string[];
  status: 'ongoing' | 'completed';
  views: number;
  altText: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'love', name: '爱情', description: '甜蜜浪漫的恋爱故事，心动瞬间令人沉醉', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', description: '穿越异世界，魔法与冒险的精彩旅程', icon: 'ri-magic-line', count: 95 },
  { slug: 'action', name: '动作', description: '热血沸腾的战斗场面，强者之路不停歇', icon: 'ri-sword-line', count: 87 },
  { slug: 'suspense', name: '悬疑', description: '扣人心弦的推理故事，真相等待揭开', icon: 'ri-search-eye-line', count: 63 },
  { slug: 'comedy', name: '搞笑', description: '轻松幽默的日常喜剧，笑到停不下来', icon: 'ri-emotion-laugh-line', count: 74 },
  { slug: 'drama', name: '剧情', description: '深刻感人的人生故事，情感共鸣直击心灵', icon: 'ri-movie-line', count: 56 },
];

export const manhuaList: Manhua[] = [
  {
    id: 'sweet-secret',
    title: '甜蜜的秘密',
    author: '韩国漫画家协会',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20warm%20smile%20wearing%20casual%20sweater%2C%20soft%20romantic%20lighting%2C%20clean%20light%20beige%20background%2C%20webtoon%20art%20style%2C%20delicate%20lineart%2C%20pastel%20color%20palette%2C%20sweet%20romance%20atmosphere%2C%20simple%20composition%20with%20bokeh%20effect&width=400&height=560&seq=mh-cover-01&orientation=portrait',
    description: '高冷总裁与普通女孩的意外邂逅，一段隐藏在办公室背后的甜蜜恋情悄然展开。李明宇是公司里人人敬畏的年轻总裁，而张晓雪只是刚入职的小职员。一次偶然的加班，让两人的命运开始交织在一起。在繁忙的工作与复杂的人际关系中，他们能否守护这份来之不易的感情？',
    category: '爱情',
    categorySlug: 'love',
    rating: 4.8,
    latestChapter: '第128话 告白',
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-128', number: 128, title: '告白', createdAt: '2026-07-02' },
      { id: 'ch-127', number: 127, title: '误会解除', createdAt: '2026-06-28' },
      { id: 'ch-126', number: 126, title: '意外的相遇', createdAt: '2026-06-25' },
    ],
    tags: ['恋爱', '职场', '甜宠', '总裁'],
    status: 'ongoing',
    views: 2580000,
    altText: '甜蜜的秘密 韩漫 爱情漫画',
  },
  {
    id: 'magic-academy',
    title: '魔法学院的劣等生',
    author: '星空工作室',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20male%20magician%20with%20silver%20hair%20holding%20a%20glowing%20spell%20book%2C%20wearing%20academy%20uniform%20with%20cape%2C%20magical%20energy%20surrounding%20him%2C%20fantasy%20style%2C%20clean%20light%20background%20with%20subtle%20sparkles%2C%20webtoon%20art%20style%2C%20vibrant%20blue%20and%20gold%20accents%2C%20dynamic%20pose&width=400&height=560&seq=mh-cover-02&orientation=portrait',
    description: '被认为毫无魔法天赋的少年韩宇，在魔法学院入学测试中被认定为F级劣等生。但他隐藏着一个秘密——他拥有的不是普通的魔法，而是早已失传的远古禁术。当黑暗势力威胁学院安全时，这位"劣等生"将展现出真正的实力。',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 4.9,
    latestChapter: '第95话 觉醒',
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-95', number: 95, title: '觉醒', createdAt: '2026-07-01' },
      { id: 'ch-94', number: 94, title: '最后的试炼', createdAt: '2026-06-29' },
      { id: 'ch-93', number: 93, title: '远古遗迹', createdAt: '2026-06-26' },
    ],
    tags: ['校园', '逆袭', '魔法', '热血'],
    status: 'ongoing',
    views: 1890000,
    altText: '魔法学院的劣等生 韩漫 奇幻漫画',
  },
  {
    id: 'shadow-hunter',
    title: '暗影猎人',
    author: '黑夜创作组',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cool%20male%20warrior%20in%20black%20leather%20armor%20with%20twin%20daggers%2C%20dark%20urban%20night%20background%2C%20mysterious%20atmosphere%2C%20webtoon%20art%20style%2C%20sharp%20lineart%2C%20cool%20color%20tones%2C%20action%20pose%20with%20flowing%20cape%2C%20moonlight%20rim%20lighting%2C%20cyberpunk%20elements&width=400&height=560&seq=mh-cover-03&orientation=portrait',
    description: '在繁华都市的暗处，存在着专门猎杀恶灵的组织——暗影猎人。主角郑赫是一名退役特种兵，在一次任务中意外获得了看见灵魂的能力。从此，他白天是普通上班族，夜晚则化身为猎杀恶灵的暗影猎人。',
    category: '动作',
    categorySlug: 'action',
    rating: 4.7,
    latestChapter: '第76话 决战之夜',
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-76', number: 76, title: '决战之夜', createdAt: '2026-06-30' },
      { id: 'ch-75', number: 75, title: '潜入敌营', createdAt: '2026-06-27' },
      { id: 'ch-74', number: 74, title: '新的武器', createdAt: '2026-06-24' },
    ],
    tags: ['都市', '异能', '热血', '猎魔'],
    status: 'ongoing',
    views: 3120000,
    altText: '暗影猎人 韩漫 动作漫画',
  },
  {
    id: 'twisted-fate',
    title: '扭曲的命运',
    author: '谜题工坊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20woman%20with%20piercing%20eyes%20and%20dark%20red%20lips%2C%20half%20face%20in%20shadow%2C%20dramatic%20lighting%2C%20horror%20thriller%20mood%2C%20clean%20dark%20gray%20background%2C%20webtoon%20art%20style%2C%20detailed%20lineart%2C%20psychological%20suspense%20atmosphere%2C%20blood%20red%20accent%20color&width=400&height=560&seq=mh-cover-04&orientation=portrait',
    description: '七个陌生人在一座孤岛上醒来，发现他们都与十年前的一桩悬案有关。每个人都在隐瞒着不可告人的秘密，而岛上的连环死亡事件正在一步步逼近真相。谁是凶手，谁又是下一个受害者？',
    category: '悬疑',
    categorySlug: 'suspense',
    rating: 4.6,
    latestChapter: '第52话 第七个人',
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-52', number: 52, title: '第七个人', createdAt: '2026-07-02' },
      { id: 'ch-51', number: 51, title: '新的线索', createdAt: '2026-06-29' },
      { id: 'ch-50', number: 50, title: '密室之谜', createdAt: '2026-06-26' },
    ],
    tags: ['推理', '孤岛', '悬疑', '心理'],
    status: 'ongoing',
    views: 1450000,
    altText: '扭曲的命运 韩漫 悬疑漫画',
  },
  {
    id: 'cat-cafe-diary',
    title: '猫咪咖啡厅日记',
    author: '暖阳漫画',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20illustration%20of%20a%20cheerful%20young%20woman%20holding%20a%20fluffy%20orange%20cat%20in%20a%20cozy%20cafe%20setting%2C%20warm%20sunlight%20streaming%20through%20window%2C%20pastel%20yellow%20and%20cream%20colors%2C%20webtoon%20art%20style%2C%20soft%20lineart%2C%20happy%20and%20relaxing%20vibe%2C%20simple%20composition%2C%20cute%20and%20charming%20atmosphere&width=400&height=560&seq=mh-cover-05&orientation=portrait',
    description: '失业女孩林小喵误打误撞成为了一家猫咪咖啡厅的员工。在这里，她遇到了五只性格迥异的猫咪和一群奇葩同事。每天的咖啡厅生活都充满了搞笑与温馨，还有那个看起来很高冷但其实很暖的店长……',
    category: '搞笑',
    categorySlug: 'comedy',
    rating: 4.5,
    latestChapter: '第88话 猫猫总动员',
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-88', number: 88, title: '猫猫总动员', createdAt: '2026-07-01' },
      { id: 'ch-87', number: 87, title: '店长的秘密', createdAt: '2026-06-28' },
      { id: 'ch-86', number: 86, title: '新来的小家伙', createdAt: '2026-06-25' },
    ],
    tags: ['日常', '治愈', '萌宠', '休闲'],
    status: 'ongoing',
    views: 980000,
    altText: '猫咪咖啡厅日记 韩漫 搞笑漫画',
  },
  {
    id: 'last-train',
    title: '末班列车',
    author: '深夜创作社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20lonely%20man%20sitting%20by%20train%20window%20at%20night%2C%20rain%20on%20glass%2C%20melancholic%20atmosphere%2C%20blue%20and%20gray%20tones%2C%20soft%20lighting%2C%20webtoon%20art%20style%2C%20emotional%20depth%2C%20reflective%20mood%2C%20urban%20night%20scene%2C%20clean%20composition%20with%20warm%20highlights&width=400&height=560&seq=mh-cover-06&orientation=portrait',
    description: '每天乘坐末班列车回家的上班族金贤宇，在车厢里遇到了形形色色的人。每个人都有自己的故事：失意的音乐家、离家出走的少女、守护承诺的老人……在这趟深夜列车上，平凡人生中的感动与遗憾交织成一幅城市浮世绘。',
    category: '剧情',
    categorySlug: 'drama',
    rating: 4.9,
    latestChapter: '第34话 终点站',
    updatedAt: '2026-06-29',
    chapters: [
      { id: 'ch-34', number: 34, title: '终点站', createdAt: '2026-06-29' },
      { id: 'ch-33', number: 33, title: '最后的乘客', createdAt: '2026-06-26' },
      { id: 'ch-32', number: 32, title: '雨夜的约定', createdAt: '2026-06-23' },
    ],
    tags: ['人生', '治愈', '都市', '群像'],
    status: 'completed',
    views: 720000,
    altText: '末班列车 韩漫 剧情漫画',
  },
  {
    id: 'moonlight-garden',
    title: '月光庭院',
    author: '花间漫画社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20woman%20in%20traditional%20hanbok%20standing%20in%20a%20moonlit%20garden%20with%20cherry%20blossoms%2C%20soft%20romantic%20atmosphere%2C%20silver%20moonlight%2C%20pink%20and%20cream%20colors%2C%20webtoon%20art%20style%2C%20delicate%20lineart%2C%20historical%20romance%20vibe%2C%20beautiful%20composition%2C%20dreamy%20aesthetic&width=400&height=560&seq=mh-cover-07&orientation=portrait',
    description: '古代朝鲜王朝，贵族之女朴秀莲在月光庭院中邂逅了身份成谜的少年。两人一见钟情，却被身份与命运所阻隔。一段跨越阶级的浪漫爱情，在动荡的时代背景下，能否冲破重重阻碍？',
    category: '爱情',
    categorySlug: 'love',
    rating: 4.9,
    latestChapter: '第115话 重逢',
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-115', number: 115, title: '重逢', createdAt: '2026-07-02' },
      { id: 'ch-114', number: 114, title: '离别信', createdAt: '2026-06-29' },
      { id: 'ch-113', number: 113, title: '婚礼前夕', createdAt: '2026-06-26' },
    ],
    tags: ['古风', '恋爱', '宫斗', '虐恋'],
    status: 'ongoing',
    views: 4210000,
    altText: '月光庭院 韩漫 古风爱情漫画',
  },
  {
    id: 'dragon-lord',
    title: '龙王归来',
    author: '龙腾工作室',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20with%20dragon%20scale%20armor%20and%20glowing%20eyes%2C%20standing%20on%20a%20cliff%20with%20dragon%20wings%20extended%2C%20epic%20fantasy%20scene%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20webtoon%20art%20style%2C%20gold%20and%20crimson%20accents%2C%20powerful%20dynamic%20pose%2C%20mythical%20atmosphere&width=400&height=560&seq=mh-cover-08&orientation=portrait',
    description: '曾被封印千年的龙王，在现代都市中苏醒。他化身为一名普通高中生，适应着全新的世界。但当古老的敌人也随之苏醒，他必须重新掌握自己的力量，保护这个他已经开始喜欢上的新世界。',
    category: '奇幻',
    categorySlug: 'fantasy',
    rating: 4.8,
    latestChapter: '第67话 龙王真身',
    updatedAt: '2026-07-01',
    chapters: [
      { id: 'ch-67', number: 67, title: '龙王真身', createdAt: '2026-07-01' },
      { id: 'ch-66', number: 66, title: '远古之敌', createdAt: '2026-06-28' },
      { id: 'ch-65', number: 65, title: '校园风波', createdAt: '2026-06-25' },
    ],
    tags: ['穿越', '都市', '龙族', '战斗'],
    status: 'ongoing',
    views: 3560000,
    altText: '龙王归来 韩漫 奇幻漫画',
  },
  {
    id: 'detective-xia',
    title: '名侦探夏洛',
    author: '推理联盟',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20smart%20looking%20female%20detective%20in%20trench%20coat%20holding%20a%20magnifying%20glass%2C%20mysterious%20urban%20backdrop%2C%20noir%20atmosphere%2C%20webtoon%20art%20style%2C%20clean%20lineart%2C%20cool%20gray%20and%20warm%20amber%20accents%2C%20mystery%20detective%20vibe%2C%20confident%20expression%2C%20foggy%20street%20background&width=400&height=560&seq=mh-cover-09&orientation=portrait',
    description: '天才少女侦探夏洛，拥有超乎常人的观察力和推理能力。她与搭档——看似懒散实则敏锐的刑警李正浩一起，破解了一个又一个离奇案件。但最大的谜团，却是她自己身世的真相。',
    category: '悬疑',
    categorySlug: 'suspense',
    rating: 4.7,
    latestChapter: '第58话 最终推理',
    updatedAt: '2026-06-28',
    chapters: [
      { id: 'ch-58', number: 58, title: '最终推理', createdAt: '2026-06-28' },
      { id: 'ch-57', number: 57, title: '消失的凶器', createdAt: '2026-06-25' },
      { id: 'ch-56', number: 56, title: '不在场证明', createdAt: '2026-06-22' },
    ],
    tags: ['推理', '破案', '天才', '悬疑'],
    status: 'ongoing',
    views: 1670000,
    altText: '名侦探夏洛 韩漫 悬疑推理漫画',
  },
  {
    id: 'reborn-boss',
    title: '重生之商业帝国',
    author: '商战漫画',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20confident%20businessman%20in%20a%20sharp%20suit%20standing%20in%20front%20of%20a%20modern%20skyscraper%2C%20determined%20expression%2C%20webtoon%20art%20style%2C%20sleek%20professional%20look%2C%20clean%20blue%20sky%20background%2C%20power%20and%20ambition%20theme%2C%20strong%20composition%2C%20modern%20urban%20setting&width=400&height=560&seq=mh-cover-10&orientation=portrait',
    description: '商场失意的中年男人陈建国，意外重生回到二十年前。带着未来二十年的商业记忆，他从一家小店铺开始，一步步打造属于自己的商业帝国。但这次，他不仅要赚钱，还想弥补曾经对家人的亏欠。',
    category: '剧情',
    categorySlug: 'drama',
    rating: 4.6,
    latestChapter: '第91话 上市之路',
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-91', number: 91, title: '上市之路', createdAt: '2026-06-30' },
      { id: 'ch-90', number: 90, title: '对手的反击', createdAt: '2026-06-27' },
      { id: 'ch-89', number: 89, title: '融资谈判', createdAt: '2026-06-24' },
    ],
    tags: ['重生', '商战', '逆袭', '都市'],
    status: 'ongoing',
    views: 2340000,
    altText: '重生之商业帝国 韩漫 剧情漫画',
  },
  {
    id: 'mixed-martial-arts',
    title: '综合格斗王',
    author: '热血漫画社',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20muscular%20fighter%20in%20fighting%20stance%20wearing%20MMA%20gloves%2C%20intense%20determined%20expression%2C%20dynamic%20action%20pose%2C%20webtoon%20art%20style%2C%20ring%20background%20with%20spotlights%2C%20bold%20lineart%2C%20warm%20orange%20and%20red%20accents%2C%20fighting%20spirit%20vibe&width=400&height=560&seq=mh-cover-11&orientation=portrait',
    description: '曾是拳击冠军的赵泰浩，因伤退役后一度沉沦。在最低谷时，他接触到了综合格斗，重新找回了生活的意义。从零开始学习各种格斗技巧，他要证明：真正的强者，永远不会被打倒。',
    category: '动作',
    categorySlug: 'action',
    rating: 4.7,
    latestChapter: '第82话 冠军之战',
    updatedAt: '2026-07-02',
    chapters: [
      { id: 'ch-82', number: 82, title: '冠军之战', createdAt: '2026-07-02' },
      { id: 'ch-81', number: 81, title: '半决赛', createdAt: '2026-06-29' },
      { id: 'ch-80', number: 80, title: '新必杀技', createdAt: '2026-06-26' },
    ],
    tags: ['格斗', '热血', '竞技', '逆袭'],
    status: 'ongoing',
    views: 2890000,
    altText: '综合格斗王 韩漫 动作漫画',
  },
  {
    id: 'pet-hospital',
    title: '宠物医院的故事',
    author: '暖暖工作室',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20style%20illustration%20of%20a%20kind%20female%20veterinarian%20with%20a%20golden%20retriever%20and%20a%20kitten%2C%20warm%20clinic%20setting%2C%20soft%20sunlight%2C%20pastel%20colors%2C%20webtoon%20art%20style%2C%20heartwarming%20scene%2C%20gentle%20expression%2C%20clean%20composition%2C%20cozy%20and%20healing%20atmosphere&width=400&height=560&seq=mh-cover-12&orientation=portrait',
    description: '刚毕业的兽医专业学生苏小暖，来到一家宠物医院实习。在这里，她遇到了各种可爱的宠物和它们的主人，每一天都充满了欢笑与泪水。从害怕大型犬到成为出色的兽医，这是一个关于成长与爱的故事。',
    category: '搞笑',
    categorySlug: 'comedy',
    rating: 4.4,
    latestChapter: '第62话 领养日',
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-62', number: 62, title: '领养日', createdAt: '2026-06-30' },
      { id: 'ch-61', number: 61, title: '走失的猫咪', createdAt: '2026-06-27' },
      { id: 'ch-60', number: 60, title: '勇敢的哈士奇', createdAt: '2026-06-24' },
    ],
    tags: ['日常', '宠物', '治愈', '成长'],
    status: 'ongoing',
    views: 850000,
    altText: '宠物医院的故事 韩漫 搞笑漫画',
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20simple%20cartoon%20avatar%20of%20a%20young%20man%20with%20glasses%20and%20messy%20hair%2C%20friendly%20smile%2C%20flat%20illustration%20style%2C%20clean%20background%2C%20warm%20colors&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    title: '资源太全了！',
    comment: '在韩漫网找到了好多之前找不到的漫画，更新速度也超快，每天都在期待新章节！',
    time: '2天前',
  },
  {
    id: 't2',
    name: '阿琳爱看漫画',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20simple%20cartoon%20avatar%20of%20a%20young%20woman%20with%20long%20hair%20and%20big%20eyes%2C%20sweet%20smile%2C%20flat%20illustration%20style%2C%20pastel%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    title: '下拉式阅读体验超棒',
    comment: '不用翻页的感觉太好了！一口气看了三十多话，体验非常流畅，强烈推荐给所有漫画爱好者。',
    time: '3天前',
  },
  {
    id: 't3',
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cartoon%20avatar%20of%20a%20cool%20looking%20person%20with%20headphones%2C%20minimalist%20flat%20style%2C%20dark%20warm%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    title: '分类找漫画太方便了',
    comment: '分类做得特别好，按类型找漫画一目了然。悬疑和剧情类是我的最爱，每次都能发现宝藏新作。',
    time: '5天前',
  },
  {
    id: 't4',
    name: '治愈系少女',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20simple%20cartoon%20avatar%20of%20a%20girl%20with%20twin%20tails%20and%20pink%20cheeks%2C%20happy%20expression%2C%20flat%20illustration%20style%2C%20soft%20pastel%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 4,
    title: '每天都来刷更新',
    comment: '韩漫网的更新频率太给力了，每天都有新内容。爱情类漫画特别好看，甜蜜的秘密是我的最爱！',
    time: '1周前',
  },
  {
    id: 't5',
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cartoon%20avatar%20of%20a%20middle%20aged%20man%20with%20beard%2C%20friendly%20face%2C%20minimalist%20flat%20style%2C%20earthy%20warm%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    title: '画质一流，内容丰富',
    comment: '看韩漫好多年了，韩漫网是我用过最好的平台。画质清晰，加载速度快，漫画种类也很全面。',
    time: '1周前',
  },
  {
    id: 't6',
    name: '追更小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20simple%20cartoon%20avatar%20of%20a%20young%20person%20with%20colorful%20hair%20and%20star%20eyes%2C%20excited%20expression%2C%20flat%20illustration%20style%2C%20vibrant%20warm%20colors%2C%20clean%20background&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 4,
    title: '推荐给了所有朋友',
    comment: '已经把韩漫网安利给身边所有爱看漫画的朋友了！大家都很喜欢，网站用起来非常顺手。',
    time: '2周前',
  },
];

export const siteInfo = {
  name: '韩漫网',
  tagline: '免费观看下拉式韩漫',
  description: '韩漫网致力于为漫画爱好者提供最优质的韩漫在线阅读体验。我们收录了海量韩漫资源，涵盖爱情、奇幻、动作、悬疑、搞笑、剧情等多种类型，采用下拉式阅读方式，无需翻页即可流畅阅读。网站更新及时，内容丰富全面，是您探索韩漫世界的理想平台。',
  email: 'hello@youplz.com',
  phone: '400-888-6666',
  address: '广东省广州市天河区体育西路123号创新大厦18层',
  socialLinks: {
    weibo: 'http://youplz.com/',
    wechat: 'hanmanwang',
    qq: '8888888888',
  },
};